import { type CategoryType } from '@/common/types/category.type';
import { type ResponseItemType } from '@/common/types/response.type';
import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';
import serializeIdentifier from '@/common/utils/serialize-identifier.utility';

export interface CategoryQueryParams {
  vendorId: number;
}

export interface CategoryItemResponse {
  categoryLogItems: CategoryType[];
}

export type CategoryItemType = (
  params: CategoryQueryParams
) => Promise<ResponseItemType<CategoryItemResponse>>;

export const getCategoryItem: CategoryItemType = async (params) => {
  const client = new Client();
  const { vendorId } = params;
  const sanitizedVendorId = serializeIdentifier(vendorId.toString());
  const path =
    sanitizedVendorId !== '0' && sanitizedVendorId
      ? `/${sanitizedVendorId}`
      : '';
  return await client.get(`/v1/Shopper/Category${path}`);
};

export function useGetCategoryItem({
  enabled,
  query,
  select,
}: {
  enabled?: boolean;
  query: CategoryQueryParams;
  select?: (data: ResponseItemType<CategoryItemResponse>) => any;
}) {
  return useQuery({
    queryFn: async () => await getCategoryItem(query),
    queryKey: ['vendor-category', query],
    retry: 1,
    enabled,
    staleTime: 600000,
    select,
  });
}
